(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["accordion-row"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (e) => {
    const button = e.target.closest('.accordion-button');
    if (!button) return;

    const panelId = button.getAttribute('aria-controls');
    const panel = document.getElementById(panelId);

    const expanded = button.getAttribute('aria-expanded') === 'true';
    const newState = !expanded;

    button.setAttribute('aria-expanded', String(newState));
    panel.inert = !newState;
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["atc-button"] && !Shopify.designMode) return;
  try {
    async function addToCart(form) {
    const isGus = window.location.pathname.includes('gus');

    if (!isGus) {
      const formData = new FormData(form);
      const variantId = Number(formData.get('id'));
      const qtyToAdd = Number(formData.get('quantity') || 1);

      const formProperties = {};
      for (const [key, value] of formData) {
        if (key.startsWith('properties[') && key.endsWith(']')) {
          formProperties[key.slice('properties['.length, -1)] = value;
        }
      }

      try {
        const cartRes = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
        if (cartRes.ok) {
          const cart = await cartRes.json();
          const existingIdx = (cart.items || []).findIndex((item) => {
            if (item.variant_id !== variantId) return false;
            return Object.entries(formProperties).every(
              ([k, v]) => (item.properties || {})[k] === v
            );
          });

          if (existingIdx >= 0) {
            const existing = cart.items[existingIdx];
            const res = await fetch('/cart/change.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
              },
              body: JSON.stringify({
                line: existingIdx + 1,
                quantity: existing.quantity + qtyToAdd,
                sections: ['cart-drawer'],
              }),
            });
            if (!res.ok) throw new Error('Add to cart failed');
            return res.json();
          }
        }
      } catch (e) {
        if (e instanceof Error && e.message === 'Add to cart failed') throw e;
      }

      formData.append('sections', 'cart-drawer');

      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
        },
        body: formData,
      });

      if (!res.ok) throw new Error('Add to cart failed');
      return res.json();
    }

    const formData = new FormData(form);
    const mainVariantId = Number(formData.get('id'));
    const mainQty = Number(formData.get('quantity') || 1);

    const items = [{ id: mainVariantId, quantity: mainQty }];

    const arcChecked = document.querySelectorAll('.arc input[type="checkbox"]:checked');

    arcChecked.forEach((input) => {
      items.push({
        id: Number(input.value),
        quantity: 1,
      });
    });

    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({ items, sections: ['cart-drawer'] }),
    });

    if (!res.ok) throw new Error('Add to cart failed');
    return res.json();
  }

  function syncBundlerCart(data) {
    const cart = data && Array.isArray(data.items) ? data : undefined;
    if (typeof window.__runBundlerCartSync === 'function') {
      window.__runBundlerCartSync(cart);
    } else if (window.bndlr && typeof window.bndlr.updateCartDiscounts === 'function') {
      window.bndlr.updateCartDiscounts();
    }
  }

  async function revealAddedItem(data) {
    const html = data?.sections?.['cart-drawer'];
    if (html && typeof window.replaceCartDrawer === 'function') {
      window.replaceCartDrawer(html);
    } else if (typeof window.refreshCartDrawer === 'function') {
      await window.refreshCartDrawer();
    }
    syncBundlerCart(data);
    window.refreshProductSection?.();
  }

  function showDrawerBusy() {
    const drawer = document.getElementById('cart-drawer');
    if (!drawer) return null;
    const wasOpen = drawer.open;
    drawer.setAttribute('aria-busy', 'true');
    if (!drawer.querySelector('.cart-drawer-progress')) {
      const progress = document.createElement('div');
      progress.className = 'cart-drawer-progress';
      progress.setAttribute('role', 'status');
      progress.innerHTML = '<span class="cart-drawer-spinner" aria-hidden="true"></span><p>Adding to cart</p>';
      drawer.appendChild(progress);
    }
    if (!wasOpen) drawer.showModal();
    return { drawer, wasOpen };
  }

  function clearDrawerBusy(shown) {
    if (!shown) return;
    shown.drawer.removeAttribute('aria-busy');
    shown.drawer.querySelector('.cart-drawer-progress')?.remove();
  }

  const dialog = document.getElementById('backorder-dialog');
  const confirmBtn = dialog?.querySelector('[data-confirm-backorder]');

  let pendingForm = null;

  confirmBtn?.addEventListener('click', async () => {
    confirmBtn.toggleAttribute('adding-to-cart', true);
    const drawer = document.getElementById('cart-drawer');
    const wasOpen = !!drawer?.open;

    try {
      const data = await addToCart(pendingForm);
      dialog.close();
      if (drawer && !drawer.open) drawer.showModal();
      await revealAddedItem(data);
    } catch (e) {
      if (drawer && !wasOpen) drawer.close();
    } finally {
      confirmBtn.toggleAttribute('adding-to-cart', false);
      pendingForm = null;
    }
  });

  document.addEventListener('submit', async (e) => {
    const form = e.target;
    if (form.method === 'dialog') return;
    if (!form.action.includes('/cart/add')) return;

    e.preventDefault();

    const variant = form.querySelector('input[name="id"]:checked') || form.querySelector('input[name="id"]');
    const isBackordered = variant?.dataset.availability === 'backordered';

    if (!isBackordered) {
      form.toggleAttribute('adding-to-cart', true);
      const shown = showDrawerBusy();

      try {
        const data = await addToCart(form);
        await revealAddedItem(data);
      } catch (err) {
        if (shown && !shown.wasOpen) shown.drawer.close();
      } finally {
        clearDrawerBusy(shown);
        form.toggleAttribute('adding-to-cart', false);
      }
      return;
    }

    pendingForm = form;
    dialog.showModal();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["image-carousel"] && !Shopify.designMode) return;
  try {
    function initCarousel(root) {
  const track = root.querySelector('.image-carousel-track');
  if (!track) return;

  const slides = Array.from(track.children);
  if (!slides.length) return;

  const dots = Array.from(root.querySelectorAll('.image-carousel-dot'));
  const prevBtn = root.querySelector('.image-carousel-nav.prev');
  const nextBtn = root.querySelector('.image-carousel-nav.next');

  if (dots.length !== slides.length) return;

  let slideWidth = track.clientWidth;
  let ticking = false;

  /* ------------------ helpers ------------------ */

  function getIndex() {
    return Math.round(track.scrollLeft / slideWidth);
  }

  function updateActiveDot() {
    const index = getIndex();
    dots.forEach((dot, i) => {
      if (i === index) dot.setAttribute('active', '');
      else dot.removeAttribute('active');
    });
  }

  function scrollToSlide(index) {
    track.scrollTo({
      left: slideWidth * index,
      behavior: 'smooth',
    });
  }

  /*
    TELEPORT SCROLL
    Converts long jumps into a single-slide animation.
  */
  function jumpToSlide(targetIndex) {
    const currentIndex = getIndex();
    const distance = Math.abs(targetIndex - currentIndex);

    // adjacent slides still use native scrolling
    if (distance <= 1) {
      scrollToSlide(targetIndex);
      return;
    }

    const targetSlide = slides[targetIndex];
    const currentSlide = slides[currentIndex];
    const dir = targetIndex > currentIndex ? 1 : -1;

    // remember original position
    const placeholder = document.createElement('div');
    targetSlide.after(placeholder);

    // move slide next to current slide
    if (dir === 1) currentSlide.after(targetSlide);
    else currentSlide.before(targetSlide);

    // temporarily disable snap
    const originalSnap = track.style.scrollSnapType;
    track.style.scrollSnapType = 'none';

    if (dir === -1) track.scrollLeft += slideWidth;

    const from = track.scrollLeft;
    const to = from + dir * slideWidth;
    const duration = 380;
    const start = performance.now();
    const ease = t => 1 - Math.pow(1 - t, 3);

    function animate(now) {
      const p = Math.min((now - start) / duration, 1);
      track.scrollLeft = from + (to - from) * ease(p);

      if (p < 1) {
        requestAnimationFrame(animate);
        return;
      }

      // restore DOM order
      placeholder.before(targetSlide);
      placeholder.remove();

      // jump to real location
      track.scrollLeft = targetSlide.offsetLeft;

      requestAnimationFrame(() => {
        track.style.scrollSnapType = originalSnap;
      });
    }

    requestAnimationFrame(animate);
  }

  /* ------------------ events ------------------ */

  track.addEventListener('scroll', () => {
    if (!ticking) {
      requestAnimationFrame(() => {
        updateActiveDot();
        ticking = false;
      });
      ticking = true;
    }
  });

  dots.forEach((dot) => {
    dot.addEventListener('click', () => {
      const idx = parseInt(dot.dataset.index, 10);
      if (!Number.isNaN(idx)) {
        jumpToSlide(idx);
      }
    });
  });

  if (prevBtn) {
    prevBtn.addEventListener('click', () => {
      const prev = Math.max(0, getIndex() - 1);
      jumpToSlide(prev);
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', () => {
      const next = Math.min(slides.length - 1, getIndex() + 1);
      jumpToSlide(next);
    });
  }

  const resizeObserver = new ResizeObserver(() => {
    slideWidth = track.clientWidth;
  });
  resizeObserver.observe(track);
}

document.querySelectorAll('.image-carousel').forEach(initCarousel);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["image-compare"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.image-compare-viewport').forEach((viewport) => {
    function update(clientX) {
      const rect = viewport.getBoundingClientRect();
      const x = Math.max(0, Math.min(clientX - rect.left, rect.width));
      viewport.style.setProperty('--split', `${(x / rect.width) * 100}%`);
    }

    viewport.addEventListener('pointerdown', (event) => {
      viewport.setPointerCapture(event.pointerId);
      update(event.clientX);
    });

    viewport.addEventListener('pointermove', (event) => {
      if (!viewport.hasPointerCapture(event.pointerId)) return;
      update(event.clientX);
    });

    viewport.addEventListener('pointerup', (event) => {
      if (viewport.hasPointerCapture(event.pointerId)) {
        viewport.releasePointerCapture(event.pointerId);
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["predictive-search"] && !Shopify.designMode) return;
  try {
    const trigger = document.querySelector('a[href="/search"]');
  const search = document.getElementById('search');
  const searchInput = search?.querySelector('input[name="q"]');
  const searchClose = search?.querySelector('[type="button"]');
  const searchResults = search?.querySelector('#search-results');
  const sectionId = search?.dataset.sectionId;
  let typingTimer;
  const debounceDelay = 200;

  function preventBackgroundScroll(event) {
    // Allow scrolling only inside the results list; block the backdrop,
    // form, and the page behind (which can leak while the keyboard is open).
    if (searchResults && searchResults.contains(event.target)) return;
    event.preventDefault();
  }

  function openSearch() {
    if (!search) return;

    const mobileNav = document.querySelector('.mobile-nav');
    if (mobileNav?.hasAttribute('open')) {
      mobileNav.removeAttribute('open');
      mobileNav.setAttribute('inert', '');
      const menuBtn = document.getElementById('menu');
      menuBtn?.classList.remove('open');
      menuBtn?.classList.add('closed');
    }

    const header = document.getElementById('shopify-section-header');
    if (header) {
      search.style.setProperty('--search-top', `${header.getBoundingClientRect().bottom}px`);
    }

    if (!search.open) search.showModal();
    document.addEventListener('touchmove', preventBackgroundScroll, { passive: false });

    requestAnimationFrame(() => {
      searchInput?.focus({ preventScroll: true });
    });
  }

  function closeSearch() {
    if (!search?.open) return;
    search.close();
  }

  function clearResults() {
    if (!searchResults) return;
    searchResults.innerHTML = '';
  }

  function updateResultsFromHtml(html) {
    if (!searchResults) return;

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const newResults = doc.getElementById('search-results');

    if (!newResults) return;

    searchResults.innerHTML = newResults.innerHTML;
  }

  async function fetchPredictiveHtml(query) {
    if (!sectionId) return;

    if (!query) {
      clearResults();
      return;
    }

    const url =
      `/search/suggest?q=${encodeURIComponent(query)}` +
      `&resources[type]=product,collection,article,page` +
      `&resources[limit]=3` +
      `&resources[limit_scope]=each` +
      `&section_id=${encodeURIComponent(sectionId)}`;

    try {
      const response = await fetch(url, { headers: { Accept: 'text/html' } });
      if (!response.ok) return;
      const html = await response.text();
      updateResultsFromHtml(html);
    } catch (error) {
      clearResults();
    }
  }

  trigger?.addEventListener('click', (event) => {
    event.preventDefault();
    openSearch();
  });

  searchClose?.addEventListener('click', () => {
    closeSearch();
  });

  search?.addEventListener('close', () => {
    document.removeEventListener('touchmove', preventBackgroundScroll);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== '/') return;
    if (event.metaKey || event.ctrlKey || event.altKey) return;

    const target = event.target;
    if (
      target instanceof HTMLInputElement ||
      target instanceof HTMLTextAreaElement ||
      target instanceof HTMLSelectElement ||
      target?.isContentEditable
    ) {
      return;
    }

    event.preventDefault();
    openSearch();
  });

  searchInput?.addEventListener('input', () => {
    const query = searchInput.value.trim();
    clearTimeout(typingTimer);
    typingTimer = setTimeout(() => {
      fetchPredictiveHtml(query);
    }, debounceDelay);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    if (!window.__productCardAtcClickBound) {
    window.__productCardAtcClickBound = true;

    document.addEventListener('click', (e) => {
      const button = e.target.closest('.product-card .product-card-atc');
      if (!button) return;

      if (button.dataset.contactUrl) {
        e.preventDefault();
        window.location.href = button.dataset.contactUrl;
        return;
      }

      const form = button.closest('form');
      if (!form) return;

      e.preventDefault();

      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit(button);
      } else {
        form.dispatchEvent(new SubmitEvent('submit', { bubbles: true, cancelable: true, submitter: button }));
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rewards"] && !Shopify.designMode) return;
  try {
    const REWARDS_API_BASE = 'https://resonix-rewards.fly.dev';

  function isCartPage() {
    return Boolean(document.querySelector('.cart-page'));
  }

  function getRewardsRoot() {
    if (isCartPage()) {
      return document.querySelector('.cart-page .cart-rewards');
    }
    return document.querySelector('#cart-drawer .cart-rewards');
  }

  function retargetRewardsInstance(root, instance) {
    if (!root) return root;
    root.id = 'cart-rewards-' + instance;
    root.dataset.rewardsInstance = instance;
    root.querySelectorAll('[id]').forEach((el) => {
      el.id = el.id.replace(/-(drawer|page)$/, '-' + instance);
    });
    root.querySelectorAll('[commandfor]').forEach((el) => {
      const value = el.getAttribute('commandfor');
      if (value) {
        el.setAttribute('commandfor', value.replace(/-(drawer|page)$/, '-' + instance));
      }
    });
    return root;
  }

  function syncCartPageRewardsFromDrawer() {
    if (!isCartPage()) return;
    const drawerRoot = document.querySelector('#cart-drawer .cart-rewards');
    const pageRoot = document.querySelector('.cart-page .cart-rewards');
    if (!drawerRoot || !pageRoot) return;

    const drawerHasCustomer = Boolean(drawerRoot.dataset.customerId);
    const pageHasCustomer = Boolean(pageRoot.dataset.customerId);
    const drawerHasBalance = Boolean(drawerRoot.querySelector('.rewards-message'));
    const pageHasBalance = Boolean(pageRoot.querySelector('.rewards-message'));

    if (drawerHasCustomer === pageHasCustomer && drawerHasBalance === pageHasBalance) {
      return;
    }
    if (!drawerHasCustomer && !drawerHasBalance) return;

    const clone = drawerRoot.cloneNode(true);
    retargetRewardsInstance(clone, 'page');
    pageRoot.replaceWith(clone);
  }

  window.syncCartPageRewardsFromDrawer = syncCartPageRewardsFromDrawer;

  function scheduleCartPageRewardsSync() {
    syncCartPageRewardsFromDrawer();
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', syncCartPageRewardsFromDrawer, { once: true });
    }
  }

  function inertCart(state) {
    const cart = document.querySelector(isCartPage() ? '.cart-page' : '#cart-drawer');
    if (!cart) return;

    cart.toggleAttribute('inert', !!state);
  }

  async function refreshCart() {
    if (typeof window.refreshCartDrawer === 'function') {
      await window.refreshCartDrawer();
    }

    if (isCartPage()) {
      if (typeof window.refreshCartPage === 'function') {
        await window.refreshCartPage();
      } else {
        const section = document.querySelector('.cart-page');
        if (section) {
          const sectionId = section.id.replace('shopify-section-', '');
          const res = await fetch(`${window.location.pathname}?section_id=${sectionId}`);
          if (res.ok) {
            const html = await res.text();
            const template = document.createElement('template');
            template.innerHTML = html;
            const newSection = template.content.querySelector(`#${CSS.escape(section.id)}`);
            if (newSection) section.replaceWith(newSection);
          }
        }
      }
      syncCartPageRewardsFromDrawer();
    }

    if (typeof window.__runBundlerCartSync === 'function') {
      window.__runBundlerCartSync();
    } else if (window.bndlr && typeof window.bndlr.updateCartDiscounts === 'function') {
      window.bndlr.updateCartDiscounts();
    }
  }

  function isRewardsCode(code) {
    return String(code || '').toUpperCase().startsWith('REWARDS-');
  }

  function discountCodesFromCart(cart) {
    const entries = Array.isArray(cart?.discount_codes) ? cart.discount_codes : [];
    return entries
      .map((entry) => (typeof entry === 'string' ? entry : entry?.code))
      .filter(Boolean);
  }

  function hasApplicableRewardsCode(cart) {
    const entries = Array.isArray(cart?.discount_codes) ? cart.discount_codes : [];
    return entries.some((entry) => {
      const code = typeof entry === 'string' ? entry : entry?.code;
      if (!isRewardsCode(code)) return false;
      if (typeof entry === 'object' && entry.applicable === false) return false;
      return true;
    });
  }

  async function fetchCart() {
    const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!res.ok) return null;
    return res.json();
  }

  async function setCartDiscountCodes(codes) {
    const res = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({ discount: codes.join(',') }),
    });
    if (!res.ok) {
      throw new Error('Failed to update cart discount codes');
    }
    return res.json();
  }

  function storefrontRoot() {
    const root = window.Shopify?.routes?.root || '/';
    return root.endsWith('/') ? root : `${root}/`;
  }

  function rewardsCodeFromCart(cart) {
    const entries = Array.isArray(cart?.discount_codes) ? cart.discount_codes : [];
    for (const entry of entries) {
      const code = typeof entry === 'string' ? entry : entry?.code;
      if (!isRewardsCode(code)) continue;
      if (typeof entry === 'object' && entry.applicable === false) continue;
      return code;
    }
    return null;
  }

  function rewardsCheckoutUrl(code) {
    return `${storefrontRoot()}discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent('/checkout')}`;
  }

  function clearStoredDiscountCode() {
    document.cookie = 'discount_code=; Max-Age=0; path=/';
  }

  function isCartCheckoutLink(link) {
    if (!link || !link.closest('#cart-drawer, .cart-page')) return false;
    let url;
    try {
      url = new URL(link.getAttribute('href') || '', window.location.origin);
    } catch (e) {
      return false;
    }
    return url.pathname === '/checkout' || url.pathname.endsWith('/checkout');
  }

  async function deleteRewardsDiscount(root) {
    const rewardsRoot = root || getRewardsRoot();
    const shop = rewardsRoot?.dataset.shop;
    const loggedInCustomerId = rewardsRoot?.dataset.customerId;
    await fetch(`${REWARDS_API_BASE}/apps/rewards/delete-discount`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ shop, loggedInCustomerId }),
    });
  }

  async function applyRewards(amount, root) {
    inertCart(true);

    const rewardsRoot = root || getRewardsRoot();
    const shop = rewardsRoot?.dataset.shop;
    const loggedInCustomerId = rewardsRoot?.dataset.customerId;

    let cartTotalCents = null;
    let cartSubtotalCents = null;
    try {
      const cartRes = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      if (cartRes.ok) {
        const cart = await cartRes.json();
        cartSubtotalCents = Number(cart.items_subtotal_price) || null;
        cartTotalCents = Number(cart.total_price) || null;
      }
    } catch (e) {}

    const r = await fetch(`${REWARDS_API_BASE}/apps/rewards/create-discount`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        shop,
        loggedInCustomerId,
        rewardsCents: amount,
        cartTotalCents,
        cartSubtotalCents,
      }),
    });

    if (!r.ok) {
      inertCart(false);
      let message = 'These rewards can be spent after the waiting period.';
      try {
        const text = (await r.text()).trim();
        if (text) message = text;
      } catch (e) {}
      window.alert(message);
      return;
    }

    let created = null;
    try {
      created = await r.json();
    } catch (e) {}

    const code = created?.code;
    if (!code) {
      inertCart(false);
      window.alert('Failed to apply rewards');
      return;
    }

    try {
      const cart = await fetchCart();
      const kept = discountCodesFromCart(cart).filter((existing) => !isRewardsCode(existing));
      const updatedCart = await setCartDiscountCodes([...kept, code]);
      if (!hasApplicableRewardsCode(updatedCart)) {
        await deleteRewardsDiscount(rewardsRoot);
        inertCart(false);
        window.alert(
          'Rewards could not be combined with your other discounts. Remove other promo codes or try a smaller amount.',
        );
        return;
      }
    } catch (e) {
      await deleteRewardsDiscount(rewardsRoot);
      inertCart(false);
      window.alert('Failed to apply rewards');
      return;
    }

    await refreshCart();
    inertCart(false);
  }

  async function undoRewards(root) {
    inertCart(true);

    const rewardsRoot = root || getRewardsRoot();

    try {
      const cart = await fetchCart();
      const kept = discountCodesFromCart(cart).filter((existing) => !isRewardsCode(existing));
      await setCartDiscountCodes(kept);
    } catch (e) {}

    clearStoredDiscountCode();
    await deleteRewardsDiscount(rewardsRoot);
    await refreshCart();
    inertCart(false);
  }

  let rewardsCheckoutRedirecting = false;

  document.addEventListener(
    'click',
    async (e) => {
      if (e.defaultPrevented || e.button !== 0) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      const link = e.target.closest('a');
      if (!isCartCheckoutLink(link)) return;
      if (rewardsCheckoutRedirecting) {
        e.preventDefault();
        return;
      }

      e.preventDefault();
      rewardsCheckoutRedirecting = true;
      const fallback = link.href;
      try {
        const cart = await fetchCart();
        const rewardsCode = rewardsCodeFromCart(cart);
        window.location.assign(rewardsCode ? rewardsCheckoutUrl(rewardsCode) : fallback);
      } catch (err) {
        rewardsCheckoutRedirecting = false;
        window.location.assign(fallback);
      }
    },
    true,
  );

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.rewards-button');
    if (!btn) return;
    const root = btn.closest('.cart-rewards');
    if (!root) return;
    const msg = root.querySelector('.rewards-message');
    if (!msg) return;
    const amount = Number(msg.dataset.rewards);
    if (!amount || !Number.isFinite(amount)) return;

    if (btn.dataset.applied === 'true') {
      undoRewards(root);
    } else {
      applyRewards(amount, root);
    }
  });

  document.addEventListener(
    'click',
    (e) => {
      if (e.target.closest('[id^="rewards-info"]')) e.stopPropagation();
    },
    true
  );

  scheduleCartPageRewardsSync();

  (async function cleanupStaleRewards() {
    const root = getRewardsRoot();
    const btn = root?.querySelector('.rewards-button');
    if (!btn || btn.dataset.applied !== 'true') return;

    try {
      const cart = await fetchCart();
      if (!cart) return;

      const hasActiveRewards = hasApplicableRewardsCode(cart);
      if (!hasActiveRewards) {
        await deleteRewardsDiscount(root);
        await refreshCart();
      }
    } catch (e) {}
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["scroll-buttons"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-scroll]');
    if (!btn) return;

    const group = btn.closest('[scroll-group]');
    const container = group?.querySelector('[data-scroll-container]');
    if (!container) return;

    const items = container.children;
    const direction = btn.dataset.scroll === 'right' ? 1 : -1;
    const step = items[1].offsetLeft - items[0].offsetLeft;

    const leftBtn = group.querySelector('[data-scroll="left"]');
    const rightBtn = group.querySelector('[data-scroll="right"]');

    const max = container.scrollWidth - container.offsetWidth;
    const target = Math.min(max, Math.max(0, container.scrollLeft + direction * step));

    if (leftBtn) leftBtn.disabled = target <= 0;
    if (rightBtn) rightBtn.disabled = target >= max - 1;

    group.dataset.scrolling = '';

    container.scrollTo({ left: target, behavior: 'smooth' });

    let t;
    const onScroll = () => {
      clearTimeout(t);
      t = setTimeout(() => {
        container.removeEventListener('scroll', onScroll);
        delete group.dataset.scrolling;

        const max2 = container.scrollWidth - container.offsetWidth;
        if (leftBtn) leftBtn.disabled = container.scrollLeft <= 0;
        if (rightBtn) rightBtn.disabled = container.scrollLeft >= max2 - 1;
      }, 80);
    };

    container.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  });

  document.querySelectorAll('[scroll-group]').forEach((group) => {
    const container = group.querySelector('[scroll-container]');
    if (!container) return;

    const leftBtn = group.querySelector('[data-scroll="left"]');
    const rightBtn = group.querySelector('[data-scroll="right"]');
    if (!leftBtn && !rightBtn) return;

    const updateButtons = () => {
      if (group.hasAttribute('data-scrolling')) return;

      const max = container.scrollWidth - container.offsetWidth;
      if (leftBtn) leftBtn.disabled = container.scrollLeft <= 0;
      if (rightBtn) rightBtn.disabled = container.scrollLeft >= max - 1;
    };

    container.addEventListener('scroll', updateButtons, { passive: true });
    updateButtons();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["scroll-group"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-scroll]');
    if (!btn) return;

    const group = btn.closest('[scroll-group]');
    const container = group?.querySelector('[scroll-container]');
    if (!container) return;

    const items = container.children;
    if (!items.length) return;

    const direction = btn.dataset.scroll === 'right' ? 1 : -1;

    const styles = getComputedStyle(container);
    const gap = parseFloat(styles.columnGap || styles.gap || 0);
    const step = items[0].getBoundingClientRect().width + gap;

    const max = container.scrollWidth - container.clientWidth;
    const target = Math.round(Math.min(max, Math.max(0, container.scrollLeft + direction * step)));

    const leftBtn = group.querySelector('[data-scroll="left"]');
    const rightBtn = group.querySelector('[data-scroll="right"]');

    container.scrollTo({ left: target, behavior: 'smooth' });

    // update disabled state after scroll settles
    let t;
    const onScroll = () => {
      clearTimeout(t);
      t = setTimeout(() => {
        container.removeEventListener('scroll', onScroll);

        const max2 = container.scrollWidth - container.clientWidth;
        if (leftBtn) leftBtn.disabled = container.scrollLeft <= 0;
        if (rightBtn) rightBtn.disabled = container.scrollLeft >= max2 - 1;
      }, 80);
    };

    container.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  });

  document.querySelectorAll('[scroll-group]').forEach((group) => {
    const container = group.querySelector('[scroll-container]');
    if (!container) return;

    const leftBtn = group.querySelector('[data-scroll="left"]');
    const rightBtn = group.querySelector('[data-scroll="right"]');
    if (!leftBtn && !rightBtn) return;

    const updateButtons = () => {
      const max = container.scrollWidth - container.clientWidth;
      if (leftBtn) leftBtn.disabled = container.scrollLeft <= 0;
      if (rightBtn) rightBtn.disabled = container.scrollLeft >= max - 1;
    };

    container.addEventListener('scroll', updateButtons, { passive: true });
    updateButtons();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["short-description"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const button = event.target.closest('.read-more');
    if (!button) return;

    const id = button.getAttribute('aria-controls');
    const content = id ? document.getElementById(id) : null;
    if (!content) return;

    const expanded = button.getAttribute('aria-expanded') === 'true';

    button.setAttribute('aria-expanded', String(!expanded));
    button.textContent = expanded ? 'Read more' : 'Read less';
    content.classList.toggle('three-line-clamp', expanded);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["show-more"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (e) => {
    const btn = e.target.closest('[show-more-toggle]');
    if (!btn) return;

    const panel = document.getElementById(btn.getAttribute('aria-controls'));
    if (!panel) return;

    const label = btn.querySelector('[show-more-label]');

    const open = panel.toggleAttribute('open');

    btn.setAttribute('aria-expanded', open);
    panel.inert = !open;

    if (label) {
      label.textContent = open ? 'Show less' : 'Show more';
    }
  });
  } catch(e) { console.error(e); }
})();

})();
